import type { EventList } from '../../types';
import { commonFields } from '../../utils/defaultValues';

export const kiwiCredit: EventList = {
  KIWICREDIT_LOADED: { ...commonFields, category: 'kiwiCredit', action: ' loaded' },
  KIWICREDIT_CLICK_BID: { ...commonFields, category: 'kiwiCredit', action: 'kiwicredit click bid' },
  KIWICREDIT_SHOW_MORE: { ...commonFields, category: 'kiwiCredit', action: 'kiwicredit show more' },
};
